module.exports = __webpack_public_path__ + "static/media/principal.99ed64b1.jpeg";